import { BellOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Layout, Row, Typography, Breadcrumb } from "antd";
import { Outlet, Link, useNavigate } from "react-router-dom"
import { HomeOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;
const Main_layout = (props) => {
    const navigate = useNavigate();

    return (<>
        <Layout
            style={{
                margin: '0.1rem'
            }}
        >
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Row >
                        <Col span={24}>
                            <Row>
                                <Col>
                                    <Typography.Title level={2}>{props.title}</Typography.Title>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify={'space-between'}>
                        <Col >
                            <Row>
                                <Col>
                                    <Breadcrumb>
                                        <Breadcrumb.Item>
                                            <Link to={"/"}>{<HomeOutlined />}</Link>
                                        </Breadcrumb.Item>
                                        {
                                            props.path.map((value, index) => (
                                                <Breadcrumb.Item>
                                                    <Link to={value.path}>{value.name}</Link>
                                                </Breadcrumb.Item>
                                            ))
                                        }
                                    </Breadcrumb>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Button onClick={() => navigate(-1)}>
                                上一頁
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Content
                        style={{
                            padding: '2rem',
                            backgroundColor: 'white'
                        }}
                    >
                        {props.children}
                    </Content>
                </Col>
            </Row>
            <Row gutter={[8, 16]}>
                <Col>
                </Col>
                <Col span={24}>
                    <Row justify={"end"}>
                        <Col>
                            <Button onClick={() => navigate(-1)}>
                                上一頁
                            </Button>
                        </Col>
                    </Row>

                </Col>
            </Row>
        </Layout>
    </>)
}
export default Main_layout;